/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Signup_Offer_Free_RequestsInputs */

const en_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} free requests`)
};

const zh_hans1_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次免费请求`)
};

const pt_br2_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requisições grátis`)
};

const es_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} solicitudes gratis`)
};

const fr_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requêtes gratuites`)
};

const de_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kostenlose Anfragen`)
};

const ru_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} бесплатных запросов`)
};

const it_signup_offer_free_requests = /** @type {(inputs: Signup_Offer_Free_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} richieste gratuite`)
};

/**
* | output |
* | --- |
* | "{count} free requests" |
*
* @param {Signup_Offer_Free_RequestsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const signup_offer_free_requests = /** @type {((inputs: Signup_Offer_Free_RequestsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Offer_Free_RequestsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_signup_offer_free_requests(inputs)
	if (locale === "pt-BR") return pt_br2_signup_offer_free_requests(inputs)
	if (locale === "es") return es_signup_offer_free_requests(inputs)
	if (locale === "fr") return fr_signup_offer_free_requests(inputs)
	if (locale === "de") return de_signup_offer_free_requests(inputs)
	if (locale === "ru") return ru_signup_offer_free_requests(inputs)
	if (locale === "it") return it_signup_offer_free_requests(inputs)
	return en_signup_offer_free_requests(inputs)
});